import React, { useEffect, useRef } from "react";
import * as powerbi from "powerbi-client";
import LoginButton from "./LoginButton"

const PowerBIReportEmbedded = ({ reportId, groupId, embedToken }) => {
  const reportRef = useRef(null); // Referencia al contenedor del reporte
  //const groupId = "f447d48e-62df-458d-805f-b9ecdda48218"; // Cambia según tu configuración

  useEffect(() => {
    const powerbiService = new powerbi.service.Service(
      powerbi.factories.hpmFactory,
      powerbi.factories.wpmpFactory,
      powerbi.factories.routerFactory
    );

    // Limpia cualquier instancia previa
    if (reportRef.current) {
      powerbiService.reset(reportRef.current);
    }

    // Configuración del reporte
    if (reportId && embedToken) {
      const embedConfig = {
        type: "report",
        tokenType: powerbi.models.TokenType.Aad,
        id: reportId,
        embedUrl: `https://app.powerbi.com/reportEmbed?reportId=${reportId}&groupId=${groupId}`,
        accessToken: embedToken,
        permissions: powerbi.models.Permissions.All,
        //tokenType: powerbi.models.TokenType.Embed,
        settings: {
          panes: {
            filters: { visible: false },
            pageNavigation: { visible: true },
          },
          layoutType: powerbi.models.LayoutType.FitToWidth, // Ajustar al ancho de la página
        },
      };

      try {
        powerbiService.embed(reportRef.current, embedConfig);
      } catch (error) {
        console.error("Error embedding the report:", error);
      }
    }

    return () => {
      // Limpia al desmontar el componente
      if (reportRef.current) {
        powerbiService.reset(reportRef.current);
      }
    };
  }, [reportId, embedToken]);

  return (
    <div
      ref={reportRef}
      style={{ height: "100%", width: "100%", border: "1px solid #ddd" }}
    >
      {!reportId && !embedToken && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "red" }}>
          Faltan los datos necesarios para incrustar el reporte.
        </p>
      )}
      {!reportId && embedToken && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "orange" }}>
          Esperando el ID del reporte...
        </p>
      )}
      {reportId && !embedToken && (
        <p style={{ textAlign: "center", marginTop: "20px", color: "orange" }}>
          <center><LoginButton /></center> 
        </p>
      )}
    </div>
  );
};

export default PowerBIReportEmbedded;
